(function () {
  const root = document.getElementById("vetway-chat-root");
  if (!root) return;

  // Config
  const ENDPOINT = root.dataset.endpoint || "/api/chat";

  // Lang: Allow session override, default FI if the browser starts with fi
  const LANG_KEY = "vw_chat_lang";
  const sessionLang = sessionStorage.getItem(LANG_KEY);
  let lang = sessionLang ||
    ((root.dataset.lang || navigator.language || "fi").toLowerCase().startsWith("fi") ? "fi" : "en");

  const T = (fi, en) => (lang === "fi" ? fi : en);

  // Contact action config
  const ACTION_ORDER = ["phone", "whatsapp", "email"];
  const MAX_ACTIONS  = 3;

  // Contact config
  const HARD_FALLBACK_WHATS = "+35844 766 7667";

  const PHONE  = (root.dataset.phone     || window.VETWAY_PHONE     || "+35844 766 7667").trim();
  const WHATS  = (root.dataset.whatsapp  || window.VETWAY_WHATSAPP  || HARD_FALLBACK_WHATS).trim();
  const EMAIL  = (root.dataset.email     || window.VETWAY_EMAIL     || "info@vetway.fi").trim();

  // Dental form trigger (worker returns the form schema directly for this message)
  const DENTAL_FORM_ID      = "dental_check_v1";
  const DENTAL_FORM_TRIGGER = `[FORM_START:${DENTAL_FORM_ID}]`;

  // Normalize to wa.me format
  function digitsOnly(s){ return String(s||"").replace(/\D+/g,""); }
  function waNumber(n) {
    const raw = String(n || "").trim();
    if (!raw) return "";
    if (raw.startsWith("+")) return digitsOnly(raw);     // +35844 766 7667 -> 358447667667
    const d = digitsOnly(raw);
    if (d.startsWith("0"))   return "358" + d.slice(1); // 044... -> 35844...
    if (d.startsWith("358")) return d;
    return d;
  }

  // Build default actions using the normalized number
  function defaultContactActions() {
    const wa = waNumber(WHATS);
    return [
      { type: "phone",    label: T("Soita Vetwaylle", "Call Vetway"),            href: `tel:${PHONE}` },
      { type: "whatsapp", label: T("Avaa WhatsApp-keskustelu", "Open WhatsApp"), href: `https://wa.me/${wa}` },
      { type: "email",    label: T("Lähetä sähköposti", "Send email"),           href: `mailto:${EMAIL}?subject=${encodeURIComponent(T("Kysymys Vetwaylle","Question for Vetway"))}` },
    ];
  }

  // Session flags
  const DISMISS_KEY = "vw_chat_dismissed";

  // Intro state keys
  const INTRO_COMPLETE_KEY  = "vw_intro_complete"; // set when intro fully finishes
  const INTRO_INFLIGHT_KEY  = "vw_intro_inflight"; // set while intro is printing
  const INTRO_REPLAY_KEY    = "vw_intro_replay";   // if set, force full replay next open

  let introShown = sessionStorage.getItem(INTRO_COMPLETE_KEY) === "1";
  let introSeq   = 0;
  let INTRO_TIMERS = []; // keep timeout ids so we can cancel on close

  // nudge is per-open (not stored)
  let nudgeShown = false;

  // Session id
  const SID_KEY = "vw_chat_sid_v1";
  const sid = localStorage.getItem(SID_KEY) || (crypto?.randomUUID?.() || String(Date.now()));
  localStorage.setItem(SID_KEY, sid);

  // Icons
  const BOT_ICON  = "https://cdn.shopify.com/s/files/1/0909/8123/7116/files/cropped_circle_image_4.png?v=1760385773";
  const USER_ICON = "https://cdn.shopify.com/s/files/1/0909/8123/7116/files/cropped_circle_image_1.png?v=1760385768";
  const HEADER_AVATAR = BOT_ICON;

  const SEND_ICON = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
         stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 19V5"/><path d="M5 12l7-7 7 7"/>
    </svg>`;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Touch devices (phones/tablets): don't auto-focus, it opens the keyboard
  const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

  // UI
  const btn = document.createElement("button");
  btn.className = "vw-chat-bubble";
  btn.setAttribute("aria-label", "Open Vetway chat");
  btn.setAttribute("aria-expanded", "false");
  btn.innerHTML = `
  <span class="vw-fab-wrap vw-live-wrap">
    <img src="${BOT_ICON}" alt="" class="vw-fab-icon" decoding="async" loading="lazy" />
  </span>`;

  const panel = document.createElement("section");
  panel.className = "vw-chat-panel";
  panel.setAttribute("aria-live", "polite");
  panel.innerHTML = `
<header class="vw-chat-header">
  <span class="vw-live-wrap">
    <img class="vw-header-avatar" src="${HEADER_AVATAR}" alt="" />
  </span>
  <div class="vw-header-text">
    <div class="vw-header-title">Liisa</div>
    <div class="vw-header-sub">${T("Vetwayn tekoälyavustaja","Vetway's AI assistant")}</div>
  </div>
  <button class="vw-chat-close" aria-label="${T("Sulje keskustelu","Close chat")}">×</button>
</header>
<div class="vw-chat-messages" id="vwChatMsgs"></div>
<form class="vw-chat-inputbar" id="vwChatForm">
  <input id="vwChatInput" name="q" autocomplete="off"
         placeholder='${T("Kirjoita kysymyksesi…","Type your question…")}' />
  <button type="submit" id="vwChatSendBtn" aria-label="${T("Lähetä","Send")}">${SEND_ICON}</button>
</form>`;

  document.body.appendChild(btn);
  document.body.appendChild(panel);

  const msgs       = panel.querySelector("#vwChatMsgs");
  const form       = panel.querySelector("#vwChatForm");
  const input      = panel.querySelector("#vwChatInput");
  const sendButton = panel.querySelector("#vwChatSendBtn");
  const headerSub  = panel.querySelector(".vw-header-sub");
  const closeBtn   = panel.querySelector(".vw-chat-close");

  // Keep the panel above the on-screen keyboard (fixes first-tap overlap)
  if (window.visualViewport && isTouchDevice) {
    const vv = window.visualViewport;
    const fitToKeyboard = () => {
      if (!opened) return;
      const keyboard = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      panel.style.bottom = keyboard ? keyboard + "px" : "";
      panel.style.maxHeight = keyboard ? vv.height + "px" : "";
      msgs.scrollTop = msgs.scrollHeight;
    };
    vv.addEventListener("resize", fitToKeyboard);
    vv.addEventListener("scroll", fitToKeyboard);
    input.addEventListener("focus", () => setTimeout(fitToKeyboard, 300));
  }

  // Lang switching (runtime)
  function setLang(newLang) {
    const next = (String(newLang).toLowerCase().startsWith("fi")) ? "fi" : "en";
    lang = next;
    sessionStorage.setItem(LANG_KEY, next);

    // Update visible UI labels
    headerSub.textContent = T("Vetwayn tekoälyavustaja","Vetway's AI assistant");
    input.placeholder     = T("Kirjoita kysymyksesi…","Type your question…");
    sendButton.setAttribute("aria-label", T("Lähetä","Send"));
    closeBtn.setAttribute("aria-label", T("Sulje keskustelu","Close chat"));
  }

  // Helpers
  function escapeHTML(s = "") {
    return String(s).replace(/[&<>"']/g, c => (
      { "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" }[c]
    ));
  }

  function linkifyAndFormat(raw = "") {
    // Escape first
    let s = escapeHTML(raw);

    const LOC_RE = /^(?:https?:\/\/)?(?:www\.)?vetway\.fi\/?#location\b/i;

    s = s.replace(
      /(https?:\/\/[^\s)]+)|\b(vetway\.fi[^\s)]+)/gi,
      (m, httpUrl, bare) => {
        const href = httpUrl || `https://${bare}`;
        if (LOC_RE.test(href)) {
          const label = (lang === 'fi') ? 'Katso sijainti' : 'See location';
          return `<a href="${href}" class="vw-btn-location" target="_blank" rel="noopener noreferrer">${label}</a>`;
        }
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${m}</a>`;
      }
    );

    // **bold** -> <strong>
    s = s.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

    // Newlines -> <br>
    s = s.replace(/\n/g, "<br>");
    return s;
  }

  function addMsg(role, text, { animate = false } = {}) {
    const row = document.createElement("div");
    row.className = `vw-msg ${role}${animate ? " vw-appear" : ""}`;

    const avatar = document.createElement("img");
    avatar.className = "vw-avatar";
    avatar.src = role === "bot" ? BOT_ICON : USER_ICON;
    avatar.alt = "";

    const bubble = document.createElement("div");
    bubble.className = "vw-bubble";

    if (role === "bot") {
      bubble.innerHTML = linkifyAndFormat(text || "");
    } else {
      // keep user messages plain (no HTML injection)
      bubble.textContent = text || "";
    }

    if (role === "bot") row.append(avatar, bubble);
    else row.append(bubble, avatar);

    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;

    if (animate && !prefersReduced) requestAnimationFrame(() => row.classList.add("show"));
    else row.classList.add("show");
  }

  // typing indicator
  let typingEl = null;
  function showTyping() {
    if (typingEl) return;
    typingEl = document.createElement("div");
    typingEl.className = "vw-msg bot vw-appear show";
    typingEl.innerHTML = `
      <img class="vw-avatar" src="${BOT_ICON}" alt="" />
      <div class="vw-bubble"><span class="vw-typing"><i></i><i></i><i></i></span></div>`;
    msgs.appendChild(typingEl);
    msgs.scrollTop = msgs.scrollHeight;
  }
  function hideTyping() { if (typingEl) removeNode(typingEl); typingEl = null; }
  function removeNode(n){ try{ n.remove(); }catch(_){} }

  // Remove emojis from labels if needed
  function removeEmojis(str = "") {
    return String(str).replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|[\u2600-\u26FF])/g,
      ""
    ).trim();
  }

  // Quick-reply topic chips
  const QUICK_FI = [
    { label: "💡 Palvelut",        q: "Mitä palveluita Vetway tarjoaa?" },
    { label: "💰 Hinnat",          q: "Mitä rokotukset ja hammashoito maksavat?" },
    { label: "🐾 Lemmikin oireet", q: "Haluan kysyä lemmikkini oireista" },
    { label: "📅 Varaa aika",      q: "Haluan varata ajan" },
  ];
  const QUICK_EN = [
    { label: "💡 Services",        q: "What services does Vetway offer?" },
    { label: "💰 Prices",          q: "How much do vaccinations and dental care cost?" },
    { label: "🐾 Pet symptoms",    q: "I have a question about my pet's symptoms" },
    { label: "📅 Book a visit",    q: "I want to book an appointment" },
  ];

  function clearQuickReplies() {
    msgs.querySelectorAll(".vw-quick").forEach(removeNode);
  }

  function renderQuickReplies() {
    clearQuickReplies();

    const row = document.createElement("div");
    row.className = "vw-quick";
    row.setAttribute("role", "group");
    row.setAttribute("aria-label", T("Aiheet", "Topics"));

    const items = lang === "fi"
      ? [...QUICK_FI, { label: "In English", q: "english", lang: true }]
      : [...QUICK_EN, { label: "Suomeksi",   q: "suomi",   lang: true }];

    items.forEach(item => {
      const chip = document.createElement("button");
      chip.type = "button";
      chip.className = "vw-chip" + (item.lang ? " vw-chip-lang" : "");
      chip.textContent = item.label;
      chip.addEventListener("click", () => sendMessage(item.q));
      row.appendChild(chip);
    });

    msgs.appendChild(row);

    // "or do Pikakartoitus: Hammashoito" line (shares .vw-quick so it clears with the chips)
    const extra = document.createElement("div");
    extra.className = "vw-quick vw-quick-extra";

    const pre = document.createElement("span");
    pre.textContent = T("tai tee ", "or do ");

    const link = document.createElement("button");
    link.type = "button";
    link.className = "vw-form-link";
    link.textContent = T("🦷 Pikakartoitus: Hammashoito", "🦷 Quick check: Dental care");
    link.addEventListener("click", startDentalForm);

    extra.append(pre, link);
    msgs.appendChild(extra);

    msgs.scrollTop = msgs.scrollHeight;
  }

  // Nudge when window is empty on reopen
  function renderNudgeIfEmpty() {
    if (nudgeShown) return;
    if (!opened) return;
    const hasMessages = Array.from(msgs.children).some(el => !el.querySelector?.(".vw-typing"));
    if (hasMessages) return;
    addMsg("bot", T("Kysy rohkeasti mitä vain! 😊", "Feel free to ask anything! 😊"), { animate: true });
    nudgeShown = true;
  }

  // Normalize action types
  function canonicalType(t = "") {
    const s = String(t).toLowerCase();
    if (s.includes("phone") || s.includes("call") || s === "tel") return "phone";
    if (s.includes("whats")) return "whatsapp";
    if (s.includes("mail"))  return "email";
    if (s === "handoff")     return "handoff";
    return s;
  }

  function baseFor(type) {
    const base = defaultContactActions().find(a => a.type === type);
    return base || { type, label: type, href: "#" };
  }

  // Always top-up to the trio, then order & cap
  function enrichActions(actions = []) {
    const map = new Map(); // type -> action
    const waHref = `https://wa.me/${waNumber(WHATS)}`;

    for (const raw of actions || []) {
      if (!raw || !raw.type) continue;
      const t = canonicalType(raw.type);

      if (t === "handoff") {
        defaultContactActions().forEach(a => { if (!map.has(a.type)) map.set(a.type, { ...a }); });
        continue;
      }
      if (!ACTION_ORDER.includes(t) || map.has(t)) continue;

      const base = baseFor(t);
      map.set(t, {
        type: t,
        label: raw.label || base.label,
        href: raw.href || base.href ||
              (t === "phone" ? `tel:${PHONE}` :
               t === "whatsapp" ? waHref :
               t === "email" ? `mailto:${EMAIL}` : "#"),
      });
    }

    ACTION_ORDER.forEach(t => { if (!map.has(t)) map.set(t, baseFor(t)); });

    const ordered = ACTION_ORDER.map(t => map.get(t)).filter(Boolean);
    return ordered.slice(0, MAX_ACTIONS);
  }

  function renderActions(actions = [], direct = false) {
    const list = enrichActions(actions);
    if (!list.length) return;

    const row = document.createElement("div");
    row.className = "vw-msg bot show has-actions";

    const avatar = document.createElement("img");
    avatar.className = "vw-avatar";
    avatar.src = BOT_ICON;
    avatar.alt = "";

    const bubble = document.createElement("div");
    bubble.className = "vw-bubble";

    if (direct) {
      const line = document.createElement("div");
      line.textContent = T("Tässä vaihtoehdot 👇","Here are your options 👇");
      line.style.marginBottom = "8px";
      bubble.appendChild(line);
    }

    const wrap = document.createElement("div");
    wrap.className = "vw-actions";

    list.forEach(a => {
      const link = document.createElement("a");
      link.className = `vw-action vw-${a.type}`;
      link.textContent = removeEmojis(a.label || a.type);
      link.href = a.href || "#";
      if (/^https?:|^mailto:|^tel:/i.test(link.href)) {
        link.target = "_blank";
        link.rel = "noopener noreferrer";
      }
      wrap.appendChild(link);
    });

    bubble.appendChild(wrap);
    row.append(avatar, bubble);
    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function renderConnectPrompt(actions) {
    const row = document.createElement("div");
    row.className = "vw-msg bot show";

    const avatar = document.createElement("img");
    avatar.className = "vw-avatar";
    avatar.src = BOT_ICON;
    avatar.alt = "";

    const bubble = document.createElement("div");
    bubble.className = "vw-bubble";

    const question = document.createElement("div");
    question.textContent = T("Haluatko, että yhdistän sinut Vetwayn tiimille?",
                             "Would you like me to connect you with the Vetway team?");
    question.style.marginBottom = "8px";

    const wrap = document.createElement("div");
    wrap.className = "vw-actions";

    let handled = false;

    const yes = document.createElement("a");
    yes.className = "vw-action vw-yes";
    yes.textContent = T("Kyllä, näytä vaihtoehdot", "Yes, show options");
    yes.href = "#";
    yes.addEventListener("click", (e) => {
      e.preventDefault();
      if (handled) return;
      handled = true;
      yes.setAttribute("aria-disabled","true");
      removeNode(row);
      renderActions(actions, true);
    });

    const no = document.createElement("a");
    no.className = "vw-action vw-no";
    no.textContent = T("Ei kiitos", "No thanks");
    no.href = "#";
    no.addEventListener("click", (e) => {
      e.preventDefault();
      if (handled) return;
      handled = true;
      removeNode(row);
    });

    wrap.append(yes, no);
    bubble.append(question, wrap);
    row.append(avatar, bubble);
    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function userAskedToConnect(q) {
    const s = (q || "").toLowerCase();
    const vetwayish = /(vetway|vetwey|veyway|vetwai)/i;
    const fi = /(yhdist(ä|a)|ota yhteyttä|soita|whatsapp|sähköposti|lähetä|laheta|laita viestiä)/i;
    const en = /(connect|contact|get in touch|call|phone|whatsapp|email|mail)/i;
    return (fi.test(s) || en.test(s)) && vetwayish.test(s);
  }

  // Open / Close
  let opened = false;
  let autoTimer = null;

  function openPanel() {
    if (opened) return;
    opened = true;
    nudgeShown = false;

    panel.classList.add("open");
    btn.setAttribute("aria-expanded", "true");

    // Only auto-focus on desktop; on phones this would pop up the keyboard
    if (!isTouchDevice) input?.focus();

    // decide whether to replay full intro
    const shouldReplay =
      sessionStorage.getItem(INTRO_REPLAY_KEY) === "1" ||
      !sessionStorage.getItem(INTRO_COMPLETE_KEY);

    if (shouldReplay) {
      // wipe any partial bubbles from the previous attempt
      msgs.innerHTML = "";
      INTRO_TIMERS = [];
      introShown = false;
    }

    renderIntroOnce().then(() => {
      renderNudgeIfEmpty();
    });
  }

  function closePanel() {
    // reset keyboard offset styles
    panel.style.bottom = "";
    panel.style.maxHeight = "";

    panel.classList.remove("open");
    opened = false;
    if (autoTimer) clearTimeout(autoTimer);
    sessionStorage.setItem(DISMISS_KEY, "1");
    btn.setAttribute("aria-expanded", "false");

    // cancel scheduled intro steps
    introSeq++;
    for (const id of INTRO_TIMERS) clearTimeout(id);
    INTRO_TIMERS = [];

    // ensure typing bubble is gone
    hideTyping();

    // if user closed mid-intro → force full replay next time
    if (sessionStorage.getItem(INTRO_INFLIGHT_KEY) === "1") {
      sessionStorage.setItem(INTRO_REPLAY_KEY, "1");
      sessionStorage.removeItem(INTRO_COMPLETE_KEY);
    }

    btn.focus();
  }

  btn.addEventListener("click", openPanel);
  closeBtn?.addEventListener("click", closePanel);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && opened) closePanel();
  });

  if (sessionStorage.getItem(DISMISS_KEY) !== "1") {
    autoTimer = setTimeout(openPanel, 5000);
  }
  btn.addEventListener("click", () => { if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; } }, { once: true });

  // Intro (once per session, cancel-safe)
  const GREET_FI =
    "Hei, olen Liisa, Vetwayn assistentti \nVoit kysyä minulta palveluista, hinnoista, lemmikkisi oireista tai ajanvarauksesta. Valitse aihe alta tai kirjoita oma kysymyksesi.";
  const GREET_EN =
    "Hi, I'm Liisa, Vetway's assistant \nAsk me about our services, prices, your pet's symptoms or booking a visit. Pick a topic below or type your own question.";

  async function renderIntroOnce() {
    if (introShown || msgs.childElementCount > 0) return;
    await renderIntro();
  }

  async function renderIntro() {
    // mark intro as running
    sessionStorage.setItem(INTRO_INFLIGHT_KEY, "1");
    sessionStorage.removeItem(INTRO_COMPLETE_KEY);

    const seq = ++introSeq;

    // trackable delay so we can cancel on close
    const delay = (ms) => new Promise(r => {
      const id = setTimeout(r, ms);
      INTRO_TIMERS.push(id);
    });
    const alive = () => (seq === introSeq && opened);

    showTyping(); await delay(900); if (!alive()) return; hideTyping();
    addMsg("bot", T(GREET_FI, GREET_EN), { animate: true });

    await delay(400); if (!alive()) return;
    renderQuickReplies();

    // intro finished successfully
    sessionStorage.setItem(INTRO_COMPLETE_KEY, "1");
    sessionStorage.removeItem(INTRO_INFLIGHT_KEY);
    sessionStorage.removeItem(INTRO_REPLAY_KEY);
    introShown = true;
  }

  // Dental: Combined gate + form

  // One bubble with price+prompt + Yes/No buttons. On "Yes" it shows the form.
  function renderDentalGate(introText, schema) {
    const row = document.createElement("div");
    row.className = "vw-msg bot show has-actions";

    const avatar = document.createElement("img");
    avatar.className = "vw-avatar";
    avatar.src = BOT_ICON;
    avatar.alt = "";

    const bubble = document.createElement("div");
    bubble.className = "vw-bubble";

    const intro = document.createElement("div");
    intro.textContent = introText;
    intro.style.marginBottom = "8px";
    bubble.appendChild(intro);

    const wrap = document.createElement("div");
    wrap.className = "vw-actions";

    const yes = document.createElement("a");
    yes.className = "vw-action vw-yes";
    yes.textContent = T("Kyllä", "Yes");
    yes.href = "#";

    const no = document.createElement("a");
    no.className = "vw-action vw-no";
    no.textContent = T("Ei", "No");
    no.href = "#";

    let handled = false;
    const removeRow = () => { try { row.remove(); } catch(_) {} };

    yes.addEventListener("click", (e) => {
      e.preventDefault();
      if (handled) return;
      handled = true;
      removeRow();
      renderFormBubble(schema);
    });

    no.addEventListener("click", (e) => {
      e.preventDefault();
      if (handled) return;
      handled = true;
      removeRow();
    });

    wrap.append(yes, no);
    bubble.appendChild(wrap);
    row.append(avatar, bubble);
    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function renderFormBubble(schema) {
    const row = document.createElement("div");
    row.className = "vw-msg bot show";

    const avatar = document.createElement("img");
    avatar.className = "vw-avatar";
    avatar.src = BOT_ICON;
    avatar.alt = "";

    const bubble = document.createElement("div");
    bubble.className = "vw-bubble";

    const title = document.createElement("div");
    title.className = "vw-form-title";
    title.textContent = schema.title || T("Pikakartoitus","Quick check");
    bubble.appendChild(title);

    const miniForm = document.createElement("form");
    miniForm.className = "vw-mini-form";

    const controls = {};

    (schema.fields || []).forEach(f => {
      const wrap = document.createElement("div");
      wrap.className = "vw-field";

      const caption = document.createElement("label");
      caption.className = "vw-field-label";
      caption.textContent = f.label || "";
      wrap.appendChild(caption);

      let field;

      if (f.type === "yesno" || f.type === "boolean") {
        // Hidden input carrying selected value
        const hidden = document.createElement("input");
        hidden.type  = "hidden";
        hidden.name  = f.id;
        hidden.dataset.fieldId = f.id;

        // Segmented Yes/No UI
        const seg = document.createElement("div");
        seg.className = "vw-yesno";
        seg.setAttribute("role", "radiogroup");
        seg.setAttribute("aria-label", f.label || "Yes or No");
        if (f.required) seg.setAttribute("aria-required", "true");

        const yesBtn = document.createElement("button");
        yesBtn.type = "button";
        yesBtn.className = "vw-yesno-option";
        yesBtn.textContent = T("Kyllä", "Yes");
        yesBtn.setAttribute("role", "radio");
        yesBtn.setAttribute("aria-checked", "false");

        const noBtn = document.createElement("button");
        noBtn.type = "button";
        noBtn.className = "vw-yesno-option";
        noBtn.textContent = T("Ei", "No");
        noBtn.setAttribute("role", "radio");
        noBtn.setAttribute("aria-checked", "false");

        function select(v) {
          hidden.value = v; // "yes" | "no"
          [yesBtn, noBtn].forEach(b => {
            const checked = (b === yesBtn && v === "yes") || (b === noBtn && v === "no");
            b.classList.toggle("is-selected", checked);
            b.setAttribute("aria-checked", checked ? "true" : "false");
          });
        }

        yesBtn.addEventListener("click", () => select("yes"));
        noBtn.addEventListener("click", () => select("no"));

        // Optional default
        if (f.default === true || f.default === "yes") select("yes");
        else if (f.default === false || f.default === "no") select("no");

        seg.append(yesBtn, noBtn);
        field = document.createElement("div");
        field.appendChild(seg);
        field.appendChild(hidden);

      } else if (f.type === "radio") {
        field = document.createElement("div");
        field.className = "vw-radio-group";

        // Map Koira/Kissa (FI) and Dog/Cat (EN) to emojis
        const toEmoji = (txt = "") => {
          const s = String(txt).toLowerCase().trim();
          if (/(koira|dog)/i.test(s)) return "🐶";
          if (/(kissa|cat)/i.test(s)) return "🐱";
          return null;
        };

        (f.options || []).forEach(opt => {
          const rWrap = document.createElement("label");
          const emoji = toEmoji(opt.label || opt.value);

          rWrap.className = "vw-radio" + (emoji ? " vw-emoji-radio" : "");
          if (emoji) rWrap.title = opt.label || opt.value;

          const r = document.createElement("input");
          r.type = "radio";
          r.name = f.id;
          r.value = opt.value;
          if (emoji) r.setAttribute("aria-label", opt.label || opt.value);

          const t = document.createElement("span");
          t.textContent = emoji ?? (opt.label || opt.value); // emoji if available

          rWrap.appendChild(r);
          rWrap.appendChild(t);
          field.appendChild(rWrap);
        });
      } else if (f.type === "number") {
        field = document.createElement("input");
        field.type = "number";
        if (f.min != null)  field.min  = f.min;
        if (f.step != null) field.step = f.step;
        field.inputMode = "numeric";
      } else {
        field = document.createElement("input");
        field.type = "text";
      }

      field.dataset.fieldId = f.id;
      if (f.required) field.dataset.required = "1";

      wrap.appendChild(field);
      miniForm.appendChild(wrap);
      controls[f.id] = field;
    });

    const submit = document.createElement("button");
    submit.type = "submit";
    submit.className = "vw-form-submit";
    submit.textContent = schema.submit_label || T("Valmis","Done");
    miniForm.appendChild(submit);

    miniForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Minimal validation for required yes/no fields
      let invalid = false;
      (schema.fields || []).forEach(f => {
        if ((f.type === "yesno" || f.type === "boolean") && f.required) {
          const hidden = miniForm.querySelector(`input[type="hidden"][name="${f.id}"]`);
          if (!hidden?.value) {
            invalid = true;
            const seg = controls[f.id].querySelector(".vw-yesno");
            seg?.classList.add("vw-invalid");
            setTimeout(() => seg?.classList.remove("vw-invalid"), 900);
          }
        }
      });
      if (invalid) return;

      // Collect values
      const payload = { __form_id: schema.id };
      (schema.fields || []).forEach(f => {
        if (f.type === "radio") {
          const chosen = miniForm.querySelector(`input[name="${f.id}"]:checked`);
          payload[f.id] = chosen ? chosen.value : "";
        } else if (f.type === "yesno" || f.type === "boolean") {
          const hidden = miniForm.querySelector(`input[type="hidden"][name="${f.id}"]`);
          const v = hidden?.value || "";
          if (f.type === "boolean") payload[f.id] = v === "yes";
          else payload[f.id] = v;
        } else if (f.type === "number") {
          const v = controls[f.id].value;
          payload[f.id] = v === "" ? null : Number(v);
        } else {
          payload[f.id] = controls[f.id].value || "";
        }
      });

      submit.disabled = true;

      try {
        showTyping();
        const res = await fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            message: `[FORM_SUBMIT:${DENTAL_FORM_ID}]`,
            session_id: sid,
            lang,
            form_data: payload
          })
        });
        hideTyping();

        const data = await res.json();
        const msg = data?.answer || T("Kiitos!","Thank you!");
        addMsg("bot", msg, { animate: true });

        const hasActions = Array.isArray(data?.actions) && data.actions.length > 0;
        if (hasActions || ["contact","handoff"].includes(data?.topic)) {
          renderConnectPrompt(hasActions ? data.actions : defaultContactActions());
        }
      } catch (err) {
        hideTyping();
        addMsg("bot", T("Lähetys epäonnistui, yritä uudelleen.","Sending failed, please try again."), { animate: true });
        console.error(err);
      } finally {
        submit.disabled = false;
      }
    });

    bubble.appendChild(miniForm);
    row.append(avatar, bubble);
    msgs.appendChild(row);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Send
  function isEnglishSwitch(s) {
    const q = (s || "").trim().toLowerCase();
    return q === "english";
  }
  function isFinnishSwitch(s) {
    const q = (s || "").trim().toLowerCase();
    return q === "finnish" || q === "suomi";
  }

  let sending = false;

  // Direct start of the dental quick check (from the intro link)
  async function startDentalForm() {
    if (sending) return;
    clearQuickReplies();
    addMsg("user", T("Pikakartoitus: Hammashoito", "Quick check: Dental care"), { animate: true });

    sending = true;
    sendButton.disabled = true;

    try {
      showTyping();
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: DENTAL_FORM_TRIGGER, session_id: sid, lang }),
      });
      hideTyping();

      if (!res.ok) throw new Error(`Network error (${res.status})`);
      const data = await res.json();

      if (data?.form?.id === DENTAL_FORM_ID) {
        if (data.answer) addMsg("bot", data.answer, { animate: true });
        renderFormBubble(data.form); // skip the Yes/No gate, user already chose the form
      } else {
        addMsg("bot",
          data?.answer || T("Lomaketta ei saatu ladattua, yritä uudelleen.", "Couldn't load the form, please try again."),
          { animate: true }
        );
      }
    } catch (err) {
      hideTyping();
      addMsg("bot",
        T("Hups! Jotain meni vikaan, yritä uudelleen pian",
          "Hmm, something went wrong. Please try again"),
        { animate: true }
      );
      console.error(err);
    } finally {
      sending = false;
      sendButton.disabled = false;
    }
  }

  async function sendMessage(raw) {
    const q = String(raw || "").trim();
    if (!q || sending) return;

    clearQuickReplies();
    addMsg("user", q, { animate: true });

    // Language hot-switch (no network call)
    if (isEnglishSwitch(q)) {
      setLang("en");
      addMsg("bot", "Great! I'll continue in English. How can I help you today? 😊", { animate: true });
      renderQuickReplies();
      return;
    }
    if (isFinnishSwitch(q)) {
      setLang("fi");
      addMsg("bot", "Hienoa! Jatketaan suomeksi. Miten voin auttaa? 😊", { animate: true });
      renderQuickReplies();
      return;
    }

    const askedDirectly = userAskedToConnect(q);

    sending = true;
    sendButton.disabled = true;

    try {
      showTyping();
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: q, session_id: sid, lang }),
      });
      hideTyping();

      if (!res.ok) throw new Error(`Network error (${res.status})`);
      const data = await res.json();

      const hasActions = Array.isArray(data?.actions) && data.actions.length > 0;
      const impliesContact = ["contact","handoff"].includes(data?.topic);
      const actions = hasActions ? data.actions : defaultContactActions();

      const hasDentalForm = data?.form && data.form.id === DENTAL_FORM_ID;

      if (hasDentalForm) {
        const combinedText = [
          (data?.answer || T("Perushammashoito maksaa 250 - 350 €.", "Basic dental costs is between €250 - €350.")),
          T(
            "Mutta ensin meidän pitää tehdä pika hammashoitokartoitus, jotta tiedän millaista hoitoa lemmikkisi tarvitsee. Haluatko täyttää lomakkeen?",
            "But first, we should do a quick dental check so I know what care your pet needs. Do you want to fill the form?"
          )
        ].join(" ");
        renderDentalGate(combinedText, data.form);
      } else {
        const answer = data?.answer || T("Valitettavasti en saanut vastausta","Sorry—no answer right now");
        if (answer) addMsg("bot", answer, { animate: true });
      }

      // Contact options (if provided/needed)
      if (hasActions || impliesContact) {
        if (data?.no_confirm) renderActions(actions);
        else renderConnectPrompt(actions);
      }
    } catch (err) {
      hideTyping();
      addMsg("bot",
        T("Hups! Jotain meni vikaan, yritä uudelleen pian",
          "Hmm, something went wrong. Please try again"),
        { animate: true }
      );
      console.error(err);
    } finally {
      sending = false;
      sendButton.disabled = false;
    }
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const q = input.value;
    input.value = "";
    sendMessage(q);
    input.focus();
  });
})();